module.exports = __webpack_public_path__ + "static/media/venus-mars.764a716f.svg";